// AUDIENCE EDITOR TEXT CONSTANTS

export const DAY_KEY = 'DAY';
export const TIME_KEY = 'TIME';
export const DISMISS_KEY = 'dismiss';

// 1. Rule Fields
export const RULE_FIELDS = {};

// 2. Platform Device Options
export const PLATFORM_DEVICE_OPTIONS = {};

// 3. Filters
export const FILTERS = {
  QUANTIFIERS: {
    [DAY_KEY]: {
      SINGULAR: 'day',
      PLURAL: 'days',
    },
    [TIME_KEY]: {
      SINGULAR: 'time',
      PLURAL: 'times',
    },
  },
  JOURNEY_INTERACTION: {
    WITHIN_LAST: 'within the last',
    WHERE_INTERACTION: 'where interaction was',
    INTERACTION_TYPES: {
      [DISMISS_KEY]: {
        PAST_TENSE: 'dismissed',
      },
    },
  },
};
